
import { Icon } from '@iconify/react';
import { DragHandle } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';

export const ChromaInputNode = ({ id, data }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)", width: "100px", alignItems: "center", justifyContent: "center" }}>
      <DragHandle />
      <div style={{ backgroundColor: "var(--content-item-bg)", padding: "0 4px", fontSize: "14px", fontWeight: 600, color: "var(--main-font-color)" }}>
        Chroma DB
      </div>
      <div>
        <Icon icon="mdi:database" style={{ fontSize: "72px", color: "var(--main-font-color)" }} />

      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} id="chroma-input" />
    </div>
  );
};

export default ChromaInputNode;
